// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"custom-input":1,"medium-input":1,"tarif-input":1,"parkobject-input":1,"contact-input":1,"bedingungen-input":1,"submit-input":1,"city-input":1,"text-message":1,"antrag-component":1}[chunkId]) return "js/app/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};